
/**
 * Stock Date Utilities
 * Shared utility functions for date formatting, working day calculations, and styling
 * Used by both cart and product page stock availability features
 */

const _stockDateLog = window.createLogger("StockDateUtils");

_stockDateLog.log("===== SCRIPT FILE LOADED =====");
_stockDateLog.log("File is being executed");

window.StockDateUtils = {
  /**
   * Format timestamp to readable date string
   * @param {number} timestamp - Unix timestamp (seconds)
   * @returns {string} - Formatted date (e.g., "Mon, Nov 24, 2025")
   */
  formatDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  },

  /**
   * Add working days to a Date (skips Saturday and Sunday)
   * @param {Date} date - Start date
   * @param {number} workingDays - Number of working days to add
   * @returns {Date} - New date after adding working days
   */
  addWorkingDays(date, workingDays) {
    const result = new Date(date);
    if (!workingDays || workingDays <= 0) return result;
    let daysToAdd = Math.floor(workingDays);
    while (daysToAdd > 0) {
      result.setDate(result.getDate() + 1);
      const dow = result.getDay();
      if (dow === 0 || dow === 6) {
        // weekend, skip
        continue;
      }
      daysToAdd -= 1;
    }
    return result;
  },

  /**
   * Get CSS styles for stock message container
   * Reuses styling from cart-backorder-calculator for consistency
   * @returns {string} - CSS style string for cart-shipping-note class
   */
  getStockMessageStyles() {
    return `
      padding-top: 1em;
      background: #ffffff;
      padding-left: 1em;
      padding-right: 1em;
      border-left: 1px solid #e5e7eb;
      border-right: 1px solid #e5e7eb;
      border-top: 1px solid #e5e7eb;
      border-bottom: 1px solid #e5e7eb;
      border-radius: 12px 12px 12px 12px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    `;
  },
};

_stockDateLog.log("Initialized");
